import type { ModuleName } from '../types/ModuleName.js';
import { inspectModule } from '../utils.js';

export const PREFIX = '[MFLoader]';

export const prefix = (message: string) => `${PREFIX} ${message}`;

export class MFError extends Error {
  public constructor(message: string, moduleId?: ModuleName) {
    super(prefix(moduleId ? `${inspectModule(moduleId)}: ${message}` : message));
  }
}
